import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ kicker, title, sub, center }) => (
  <div className={`mb-12 ${center ? "text-center mx-auto max-w-2xl" : "max-w-2xl"}`}>
    {kicker && (
      <span className="inline-block text-[#EAB308] text-xs font-bold uppercase tracking-[0.25em] mb-3">{kicker}</span>
    )}
    <h2 className="font-head text-3xl sm:text-4xl font-black tracking-tight text-white leading-tight">{title}</h2>
    {sub && <p className="text-zinc-400 mt-4 text-base leading-relaxed">{sub}</p>}
  </div>
);
